module.exports = __webpack_public_path__ + "static/img/d.6135983.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/d.png
// module id = SPLh
// module chunks = 1